import React from 'react'

function Nav() {
    return (
        <h2>
            EXPENSE TRACKER
        </h2>
    )
}

export default Nav
